import { useRef } from 'react';

import { TextField as Text, IconButton, InputAdornment, useTheme, Typography } from '@mui/material';

import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

import { IconCloseSmall, IconSearch } from 'assets/icons';

import { styled } from '@mui/system';

const TextField = styled(Text, {target: 'TextField'})(({ theme }) => ({
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    marginBottom: theme.spacing(1.5),
  }
}));
const SearchField = ({ iconSearch, value, handleChange, title, placeholder, ...props }) => {
  const { t } = useOnlineBookingLocale();
  const theme = useTheme();
  const SearchFieldRef = useRef(null);

  return (
    <>
      {title &&
        <Typography variant='h2' >
          {title}
        </Typography>
      }
      <TextField {...{placeholder}}
        title={value || placeholder}
        fullWidth
        value={value}
        onChange={(e) => handleChange(e)}
        {...props}
        autoComplete='off'
        inputRef={SearchFieldRef}
        InputProps={{
          startAdornment: iconSearch && (
            <InputAdornment position='start'>
              <IconSearch style={{fill: 'var(--mui-palette-secondary-textIconColor)'}} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <IconButton
              aria-label={t('ariaLabel.clear')}
              onClick={() => {
                handleChange('');
                SearchFieldRef &&
                SearchFieldRef.current &&
                SearchFieldRef.current.focus()

              }}
              style={{marginRight: `-${theme.spacing(1)}`}}
            >
              <IconCloseSmall style={{fill: 'var(--mui-palette-secondary-textIconColor)'}} />
            </IconButton>
          ),
        }}
      />
    </>
  )
};

export default SearchField;
